exports.version = "2.3.8"


//////////////////
// WEBPACK FOOTER
// ./~/apollo-boost/~/apollo-client/version.js
// module id = 665
// module chunks = 0